"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var participant_1 = require("./participant");
var types_1 = require("./types");
var LocalAccount = /** @class */ (function (_super) {
    __extends(LocalAccount, _super);
    function LocalAccount(connection, _roomId) {
        var _this = _super.call(this, connection) || this;
        _this._roomId = _roomId;
        return _this;
    }
    LocalAccount.prototype.toggleAudio = function () {
        this.manager.publishAudio(this.activeAudio = !this.activeAudio);
    };
    LocalAccount.prototype.toggleVideo = function () {
        this.activeVideo = !this.activeVideo;
    };
    LocalAccount.prototype.publishVideo = function () {
        this.manager.publishVideo(this.activeVideo);
    };
    LocalAccount.prototype.isModerator = function () {
        return this._role === types_1.OpenviduRole.MODERATOR;
    };
    LocalAccount.prototype.isPublisher = function () {
        return this._role === types_1.OpenviduRole.PUBLISHER;
    };
    LocalAccount.prototype.isGuest = function () {
        return this._role === types_1.OpenviduRole.SUBSCRIBER;
    };
    LocalAccount.prototype.join = function (role) {
        this._role = role;
    };
    Object.defineProperty(LocalAccount.prototype, "joined", {
        get: function () {
            return !!this._role;
        },
        enumerable: true,
        configurable: true
    });
    LocalAccount.prototype.stopVideoTracks = function () {
        this.manager.stream.getMediaStream().getVideoTracks().forEach(function (track) {
            track.stop();
        });
    };
    return LocalAccount;
}(participant_1.Participant));
exports.LocalAccount = LocalAccount;
//# sourceMappingURL=local.account.js.map